import { buildEmailMatchDefaults } from "@/lib/workflow/emailMatch";
import type { TriggerSampleOverrides } from "../../sampleGenerators";

export const emailMatchingOverrides: TriggerSampleOverrides = {
  skipKey: key => key === "html" || key === "headers",
  getValueOverride: (key, _prop, triggerPayload) => {
    if (key !== "from" && key !== "subject") return undefined;
    const defaults = buildEmailMatchDefaults({
      fromFilter: triggerPayload?.fromFilter as string | undefined,
      subjectFilter: triggerPayload?.subjectFilter as string | undefined,
    });
    return defaults[key];
  },
};
